export const colors = {
  DARKWHITE: "#dddddd",
  WHITE: "#fff",
  BLACK: "#000",
  RED: "#ff1e1d",
  GREEN: "#49BF00",
  MAIN_COLOR: "#e30052",
  SECONDARY: "#4dcc17",
  THIRDCOLOR: "#c2c9d1",
  BACKGROUND: "rgba(22,22,22,0.8)",
  GOLD: "gold",
};